import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { resolveLinkedAccountName } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/onboarding-zone/onboarding-bank-details-verification.utils';
import { FormID } from '@finxone-platform/form-action';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export const onboardingCtaValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
  ) => Observable<unknown>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.ONBOARDING_BANK_DETAILS_VERIFICATION,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri: UiZoneWidgetAttributeConfig) => {
      const key: string = attri?.['buttonActionType'] as string;

      ctaButtonSignalService.setSignal({ [key]: false });

      return store.select(FormActionState.getFormActionStateWithId(FormID.ONBOARDING_FLOW)).subscribe({
        next: (res) => {
          const formValue = res?.formData ?? {};
          ctaButtonSignalService.setSignal({
            [key]: !!(
              resolveLinkedAccountName(formValue) &&
              formValue['linkedAccountNumber'] &&
              formValue['linkedAccountSort']
            ),
          });
        },
      });
    },
  ],
]);
